import React from 'react'
import Link from 'redux-first-router-link'
import styled from 'react-emotion'
import * as pages from 'constants/pages'
import { Button } from 'shared/ui'

import themeVars from 'ui_theme/site/globals/site.variables'

const Container = styled('div')`
  display: flex;
  justify-content: center;
  padding-top: ${themeVars.big};
  ${props =>
    props.needsSeparator && `border-top: 1px solid ${themeVars.borderColor}`};
`

function AddNewIntegration({ needsSeparator }) {
  return (
    <Container needsSeparator={needsSeparator}>
      <Button
        as={Link}
        to={{
          type: pages.SETTINGS_INTEGRATIONS_PAGE,
        }}
        basic
      >
        Add an integration
      </Button>
    </Container>
  )
}

export default React.memo(AddNewIntegration)
